export const environment = {
    production: false,
    name: "dev",
    version: '1.9.6',
    isWriteLogCW: false,
    // awsCloudWatch: {
    //     awsAccessKey: "AKIAQMFF4KIADSTOOXXD",
    //     awsSecretKey: "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",
    //     awsRegion: "ap-southeast-1",
    //     logGroupName: "cognito-athena-dev",
    //     logStreamName: "ihunt"
    // },
    tenant: window.location.href.indexOf('ats-staging') > -1 ? "VNG" : "VNGSTAGING",
    sentry_dns: 'https://a6dd7674284349fa9f08beb248a2149f@o1014340.ingest.sentry.io/4504330460659712',
    sentry_tracing: ["https://hunt-dev.a4b.vn/", "https://athenahunt.athenafs.io/"],
    aws_cognito: {
        "aws_project_region": "ap-southeast-1",
        "aws_cognito_region": "ap-southeast-1",
        "aws_user_pools_id": "ap-southeast-1_AeU7cWzzV",
        "aws_user_pools_web_client_id": "4qfd5sbn3elfucqpipprjkt5f0",
        "oauth": {
            "domain": "xhunt-dev.auth.ap-southeast-1.amazoncognito.com",
            "scope": [
                "email",
                "openid",
                "phone"
            ],
            "redirectSignIn": "https://ats-staging.vng.vn/",
            "redirectSignOut": "https://ats-staging.vng.vn/",
            "responseType": "code"
        },
        "federationTarget": "COGNITO_USER_POOLS",
        "aws_cognito_username_attributes": [
            "EMAIL"
        ],
        "aws_cognito_social_providers": [],
        "aws_cognito_signup_attributes": [
            "GIVEN_NAME",
            "FAMILY_NAME"
        ],
        "aws_cognito_mfa_configuration": "OFF",
        "aws_cognito_mfa_types": [],
        "aws_cognito_password_protection_settings": {
            "passwordPolicyMinLength": 8,
            "passwordPolicyCharacters": [
                "REQUIRES_LOWERCASE",
                "REQUIRES_UPPERCASE",
                "REQUIRES_NUMBERS",
                "REQUIRES_SYMBOLS"
            ]
        },
        "aws_cognito_verification_mechanisms": [
            "EMAIL"
        ]
    },
    graphql: {
        link: "https://hrm-api-dev.a4b.vn/external/hasura/v1/graphql"
    },
    switchXcore: "https://hrm-dev.a4b.vn/#/verify-token",
    signInProvider: "xhunt-dev-ad",
    zitadel: {
        issuer: "https://zitadel-dev.a4b.vn",
        clientId: "352490162757896255", // Project ATS_TEST_1 - App Angular
        redirectUri: window.location.origin + "/auth-callback.html",
        postLogoutRedirectUri: window.location.origin + "/#/sign-in",
        scope: "openid profile email",
        responseType: "code",
        showDebugInformation: true,
        // Azure AD Identity Provider configured in Zitadel
        azureIdpId: "352580776753105881", // Zitadel-AD-OIDC-Test provider
        azureClientId: "c437ed4c-3d2c-45fb-bbf8-f1e8a7a852be" // Azure AD App Client ID
    },
    SOCKET_ENDPOINT: "https://hrwsgw-dev.a4b.vn/ws"
};
